import gql from 'graphql-tag';

export const GET_TASKS_FOR_PROGRAM_QUERY = gql`
  query GetTasksForProgramQuery($programId: Int!) {
    getTasksForProgram(programId: $programId) {
      tasks {
        taskName
        isCompleted
        metadata {
          memberCount
          workletSpecUri
          taskId
        }
      }
    }
  }
`;
